import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StockageService, environment } from '@perval/shared';
import { OrganismeService } from '../../../organisme/services/organisme.service';
import {
  CognitoService,
  DrupalService,
  UtilisateurService,
} from '../../../shared';

@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.scss'],
})
export class OauthCallbackComponent implements OnInit {
  constructor(
    private readonly cognitoService: CognitoService,
    private readonly utilisateurService: UtilisateurService,
    private readonly organismeService: OrganismeService,
    private readonly drupalService: DrupalService,
    private readonly stockageService: StockageService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    try {
      this.cognitoService.setTokensInSession('ID.Not');
      const user = await this.cognitoService.getUser();
      const username = user.preferred_username;
      await this.utilisateurService.provisioningIdNot(username);
      await this.drupalService.createSession();
      this.organismeService.synchroOrganisme();
      window.location.href = `${environment.host}/content/accueil`;
    } catch {
      this.stockageService.clear();
      await this.router.navigate(['/connexion'], {
        queryParams: { message: 'default' },
      });
    }
  }
}
